export const TOGGLE_USER = 'app/UserProfileView/TOGGLE_USER'
export const TOGGLE_USER_SUCCESS = 'app/UserProfileView/TOGGLE_USER_SUCCESS'
export const UPDATE_USER_ROLES = 'app/UserProfileView/UPDATE_USER_ROLES'
export const UPDATE_USER_ROLES_SUCCESS =
  'app/UserProfileView/UPDATE_USER_ROLES_SUCCESS'
export const RESET_PASSWORD = 'app/UserProfileView/RESET_PASSWORD'
export const RESET_PASSWORD_SUCCESS =
  'app/UserProfileView/RESET_PASSWORD_SUCCESS'
